<template>
  <div id="ms_header_downside" class="parent_div">
    <div id="header_main" class="wrapper">
      <div class="logo">
        <img :src="this.getImage('common/logo.png')" @click="onLogo()"/>
      </div>
      <div class="space" style="flex-shrink: 1"></div>
      <div>
        <div class="category" @click="onSelect()">カテゴリから商品を選ぶ</div>
        <div class="category" @click="onGuide()">ご利用ガイド</div>
        <div class="category" @click="onSupport()">お問い合わせ</div>
        <div class="category" @click="route('DcOrderSignIn', {type: 'hd'})" v-if="!isLogin">会員登録/ログイン</div>
        <div class="category" @click="route('DcMyPage')" v-else>マイページ</div>
      </div>
      <div class="icon_area">
        <div @click="goCart">
          <img :src="dispCartImg" />
        </div>
      </div>
      <div id="menu_area"> <!-- v-if="isMenuActive==false"> -->
        <div class="toggle" @click="onMenu()" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
    <dd-left-menu
      ref="menuRef"
      v-bind:class="{main_navi: true, active: isMenuActive}"
      @close="close"
    />
  </div>
</template>
<script>
import * as App from '../../../utils/App'
import {mapActions, mapState} from 'vuex'
import DDLeftMenu from '../../components/top/DcLeftMenu'
// import {PAYMENT_STATUS} from '../../../constants/Type'
import {DC_STORAGE_KEY} from '../../../constants/App'

export default {
  name: 'DcHeader',
  components: {
    'dd-left-menu': DDLeftMenu
  },
  props: {
  },
  data () {
    return {
      isMenuActive: false
    }
  },
  computed: {
    ...mapState({
      cartData: state => state.cartData
    }),
    nowList: function () {
      if (!this.cartData || !this.cartData.cartModel || Object.keys(this.cartData.cartModel.orderList).length <= 0) return {}
      return this.cartData.cartModel.orderList
    },
    dispCartImg: function () {
      if (!this.nowList.length || this.nowList.length <= 0) {
        return this.getImage('common/icon_cart.svg')
      } else {
        return this.getImage('common/icon_cart.svg')
      }
    },
    isLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 4) return false
      return true
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    route: function (name, params) {
      this.$router.push({
        name: name,
        params: params
      })
    },
    onLogo: function () {
      this.$router.push({
        name: 'DcTop'
      })
    },
    onSelect: function () {
      this.$router.push({
        name: 'DcCategory'
      })
    },
    onMenu: function () {
      this.isMenuActive = true
    },
    close: function () {
      this.isMenuActive = false
    },
    getImage: function (image) {
      return App.getYasumokuResource(image)
    },
    goCart: function () {
      this.$router.push({
        name: 'Cart'
      })
    },
    onGuide: function () {
      this.$router.push({
        name: 'DcPaymentGuide'
      })
    },
    onSupport: function () {
      this.$router.push({
        name: 'SupportInput'
      })
    }
  },
  mounted: function () {
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.$store.dispatch('loadCartData', {reload: true})
  }
}
</script>
<style src="../../css/dcheader.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/common/DcHeader.vue